export const baseTransition = "all 180ms ease" as const;

export const FONTS = {
  serif: "'Cormorant Garamond', Georgia, serif",
  sans: "'DM Sans', sans-serif",
} as const;
